/** @format */

import { Popup } from 'devextreme-react';
import { IPopupOptions } from 'devextreme-react/popup';
import { cloneElement, ReactElement, useState } from 'react';

export interface ModalTriggerProps extends Omit<IPopupOptions, 'children'> {
  children(close): ReactElement;
  button: ReactElement;
}

function ModalTrigger({ children, ...props }: ModalTriggerProps) {
  // const state = useOverlayTriggerState(props);
  // const { triggerProps, overlayProps } = useOverlayTrigger({ type: 'dialog' }, state);
  const [isOpen, setIsOpen] = useState(false);

  const popupProps = {
    show: {
      type: 'pop',
      duration: 500,
    },
  };

  const close = () => {
    setIsOpen(false);
  };

  const togglePopup = () => {
    setIsOpen((o) => !o);
  };

  return (
    <>
      {cloneElement(props.button, {
        onClick: () => {
          setIsOpen(true);
        },
      })}
      <Popup {...props} visible={isOpen} onHiding={close}>
        {cloneElement(children(close))}
        {/*<ToolbarItem options={} />*/}
      </Popup>
    </>
  );
}

export default ModalTrigger;
